<template>
  <vue-custom-scrollbar class="scroll-area">
    <div class="info-zona">
      <h2>
        Selected region information:
      </h2>
      <p>
        <input type="checkbox" v-model="undef_check_state" @change="undef_check_updated" style="cursor: pointer"/>
        Show only Non-clustered nodes
      </p>

      <p id="titol">
        Relevant terms:
      </p>
      <span v-for="(par, index) in this.paraules_destacades" v-bind:key="index" @click="$root.$emit('ToggleWordSearch',par)" style="cursor: pointer;">
        <div id="llista">{{ parWithComma(index) }}</div>
        {{ " " }}
      </span>
      <br />
      <p id="titol">
        Scopus Classification
      </p>
      <bar-chart class="chart"> </bar-chart>

      <br />

      <div class="ordered-section-header">
        <p id="titol">
          Authors ({{this.ordered_authors.length}})
        </p>
        <div v-if="this.show_cluster_authors" class="drop-down">
          <button @click="drop_down_click" v-text="drop_down_selected_option_text"></button>
          <div class="drop-down-content" :style="author_order_drop_displayed ? 'display: block;' : 'display: none;' ">
            <p @click="drop_down_select('Alfabetically', 'ABC')">Alfabetically</p>
            <p @click="drop_down_select('% of publications in region', 'PUBL')">% of publications in region</p>
            <!-- 
            <p @click="drop_down_select('Avg. edges / publication', 'CSUBJ')">Avg. edges / publication</p>
            <p @click="drop_down_select('Distribution over years (x̄ ± σ)', 'TIME')">Distribution over years (x̄ ± σ)</p>
            <p @click="drop_down_select('# scopus covered', 'SCOPUS')"># scopus covered</p>
            <p @click="drop_down_select('Avg. co-authors / publication', 'COAUTH')">Avg. co-authors / publication</p>
            -->
          </div>
        </div>
      </div>
      <div class="info-scroll-wrapper">
        <button v-if="this.show_cluster_authors" class="order-btn" title="Reverse order" @click="reverse_author_order">⇵</button>
        <vue-custom-scrollbar  v-if="this.show_cluster_authors" class="info-scroll" :settings="scroll_settings">
          <span v-for="(author, index) in this.ordered_authors" v-bind:key="index" style="cursor: pointer;">
            <div id="llista" :style="index != 0 ? 'margin-top: 10px;' : '' " @click="$root.$emit('ToggleAuthorSearch', prev_drop_down_code == 'ABC' ? author : author.substr(0, author.indexOf('(')).trim())">{{ author }}</div><br />
            {{ " " }}
          </span>
          <br />
        </vue-custom-scrollbar>
        <button class="expand-btn" :title="this.show_cluster_authors?'Hide':'Show'" @click="show_cluster_authors = !show_cluster_authors">{{this.show_cluster_authors?'▲':'▼'}}</button>
      </div>

      <br />

      <p id="titol" class="ordered-section-header" style="align-items: center;">
        Publications ({{this.documents_cluster.length}})       
        <button v-if="this.show_cluster_publications" style="margin-left: auto; margin-right: 10px" title="Download list" @click="download_publications_list">Download ⇩</button>

      </p>
      <div class="info-scroll-wrapper">
        <vue-custom-scrollbar v-if="this.show_cluster_publications" class="info-scroll" :settings="scroll_settings">
          <span v-for="(node, index) in this.documents_cluster" v-bind:key="index" style="cursor: pointer;">
            <div id="llista" :style="index != 0 ? 'margin-top: 10px;' : '' " @click="select_node(node['id_node'])">{{ node['label'] }}</div><br />
            {{ " " }}
          </span>
          <br />
        </vue-custom-scrollbar>
        <button class="expand-btn" :title="this.show_cluster_publications?'Hide':'Show'" @click="show_cluster_publications = !show_cluster_publications">{{this.show_cluster_publications?'▲':'▼'}}</button>
      </div>

      <br />

      <button @click="undisplay_zona">{{ "Close" }}</button>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import vueCustomScrollbar from "vue-custom-scrollbar";
import BarChart from "./BarChart.vue";

export default {
  components: {
    vueCustomScrollbar,
    BarChart,
  },
  name: "InfoZona",
  props: ["api_url"],
  data() {
    return {
      drop_down_selected_option_text: 'Alfabetically ⯆',
      prev_drop_down_code: 'ABC',
      ordered_authors: [],
      author_order_drop_displayed: false,
      author_descending: true,
      documents_cluster: [],
      paraules_destacades: [],
      undef_check_state: false,
      scroll_settings: {
        supressScrollX: true,
        minScrollbarLength: 50,
        maxScrollbarLength: 250
      },
      show_cluster_authors: false,
      show_cluster_publications: false,
    };
  },
  methods: {
    undisplay_zona: function() {
      this.$store.dispatch("Amaga_zona");
    },
    parWithComma(index) {
      if (index !== this.paraules_destacades.length - 1) {
        return `${this.paraules_destacades[index]},`;
      } else return this.paraules_destacades[index];
    },
    undef_check_updated() {
      this.$store.dispatch("ActualitzaShowUndef", this.undef_check_state);
    },
    calcula_dades: async function() {
      let coord = this.$store.state.coordenades_zona,
          showOnlyUndef = this.$store.getters.zona_only_undef;
      await this.get_dades_scopus(coord, showOnlyUndef);
      await this.get_paraules_destacades(coord, showOnlyUndef);
      this.carregaPieChart();
      await this.query_sorted_authors(coord, showOnlyUndef, this.prev_drop_down_code);
      await this.get_documents_cluster(coord, showOnlyUndef); 
    },
    get_paraules_destacades: function(coord, only_undefined) {
      let url =
        this.$store.getters.api_url +
        "get_regio_undefined_words" +
        "?maxX=" + coord.maxX +
        "&minX=" + coord.minX +
        "&maxY=" + coord.maxY +
        "&minY=" + coord.minY;
      if (only_undefined) url += "&undef=1";
      var self = this;
      this.paraules_destacades = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            for (let i = 0; i < response.data.length && i < 10; ++i)
              self.paraules_destacades.push(response.data[i]);
            resolve(self.paraules_destacades);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    get_dades_scopus: function(coord, only_undefined) {
      let url =
        this.$store.getters.api_url +
        "/get_quesito_regio_undefined" +
        "?maxX=" + coord.maxX +
        "&minX=" + coord.minX +
        "&maxY=" + coord.maxY +
        "&minY=" + coord.minY;
      if (only_undefined) url += "&undef=1";
      var self = this;
      this.dades_scopus = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.dades_scopus = Object.keys(response.data);
            self.$store.dispatch(
              "actualitza_dades_bar_chart_zona",
              Object.entries(response.data).sort((a, b) => b[1] - a[1])
            );
            resolve(self.dades_scopus);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    get_documents_cluster: function(coord, only_undefined) {
      let url =
        this.$store.getters.api_url +
        "/get_documents_regio" +
        "?maxX=" + coord.maxX +
        "&minX=" + coord.minX +
        "&maxY=" + coord.maxY +
        "&minY=" + coord.minY;
      if (only_undefined) url += "&undef=1";
      var self = this;
      this.documents_cluster = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.documents_cluster = response.data;
            resolve(self.documents_cluster);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    drop_down_click: function() {
      this.author_order_drop_displayed = !this.author_order_drop_displayed
      if (this.author_order_drop_displayed) {
        this.drop_down_selected_option_text = this.drop_down_selected_option_text.substring(0,this.drop_down_selected_option_text.length-1) + '⯅'
      } else {
        this.drop_down_selected_option_text = this.drop_down_selected_option_text.substring(0,this.drop_down_selected_option_text.length-1) + '⯆'
      }
    },
    drop_down_select: function(display_str, code) {
      this.author_order_drop_displayed = false;
      if (this.prev_drop_down_code != code) {
        this.drop_down_selected_option_text = display_str + ' ⯆';
        let coord = this.$store.state.coordenades_zona,
            showOnlyUndef = this.$store.getters.zona_only_undef;
        return this.query_sorted_authors(coord, showOnlyUndef, code);
      }
    },
    query_sorted_authors: function(coord, only_undefined, code) {
      this.prev_drop_down_code = code;
      let url =
        this.$store.getters.api_url +
        "/get_regio_authors" +
        "?maxX=" + coord.maxX +
        "&minX=" + coord.minX +
        "&maxY=" + coord.maxY +
        "&minY=" + coord.minY +
        '&sort=' + code;
      if (only_undefined) { url += "&undef=1"; }
      var self = this;
      this.ordered_authors = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            if (code == 'ABC') {
              self.ordered_authors = response.data;
            } /*else if (code == 'TIME') {
              self.ordered_authors = []
              for (let i = 0; i < response.data.length; i++) {
                let avg = new Date(Number(response.data[i][1])*1000);
                let new_entry = response.data[i][0] + '   (' + avg.toLocaleDateString("en-US", {month: 'short', year: 'numeric'});
                if (Number(response.data[i][2]) !== 0) {
                  let avg_plus_sd = new Date((Number(response.data[i][1])+Number(response.data[i][2]))*1000);
                  let sd = (avg_plus_sd.getFullYear() - avg.getFullYear()) + ((avg_plus_sd.getMonth() - avg.getMonth())/12);
                  new_entry = new_entry + ' ± ' + Number(sd.toFixed(2)) + ' years)'; 
                } else {
                  new_entry = new_entry + ')';
                }
                self.ordered_authors.push(new_entry);
              }
            }*/ else if (code == 'PUBL') {
              self.ordered_authors = response.data.map(function(e) {return e[0] + '   (' + Number(e[1].toFixed(2)) + '%)'});
            } else {
              // Ara que hem tret la resta això no s'hauria de cridar mai
              self.ordered_authors = response.data.map(function(e) {return e[0] + '   (' + Number(e[1].toFixed(2)) + ')'});
            }
            if (!self.author_descending) { self.ordered_authors = self.ordered_authors.reverse(); }
            resolve(self.ordered_authors);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    reverse_author_order: function() {  
      this.ordered_authors =  this.ordered_authors.reverse(); 
      this.author_descending = !this.author_descending; 
    },
    carregaPieChart: function() {
      this.$root.$emit("BarChartZona");
    },
    download_publications_list: function() {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.documents_cluster.map(e => e['label']).join('\n -------- \n')));
      element.setAttribute('download', 'ATLAS: Documents in custom region');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    select_node: function(node) {
      this.$root.$emit("SearchSelectNode", node);
    }
  },
  mounted() {
    this.undef_check_state = this.$store.getters.zona_only_undef;
    this.calcula_dades();
    this.$root.$on('ActualitzaInfoZona', () => {
      this.calcula_dades();
    });
  },
  beforeDestroy() {
    this.$root.$off('ActualitzaInfoZona');
  }
};
</script>

<style>
.order-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  margin: 2px 22px 2px 2px;
  z-index: 1;
}
.ordered-section-header {
  display: flex;
  margin-right: 20px;
  position: relative;
}
.drop-down{
  margin-left: auto;
  align-self: flex-end;
  position: relative;
}
.drop-down button{
  height: 80%;
  border: none;
  border-bottom: solid #AAA 1px;
  background: none;
  padding: 2px 10px;
  font-size: .85em;
  cursor: pointer;
}
.drop-down button:hover{
  background: #D5D5D5;
}
.drop-down-content {
  position: absolute;
  top: 100%;
  background-color: #f1f1f1;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  width: 100%;
  z-index: 1;
}
.drop-down-content p {
  color: black;
  padding: 5px 16px;
  text-decoration: none;
  display: block;
  font-size: 0.75em;
  cursor: pointer;
}
.drop-down-content p:hover {
  background: #e5e5e5;
}
#llista {
  display: inline-block;
  font-size: 14px;
  font-family: Helvetica, Arial, sans-serif;
  color: #0077c8;
  line-height: 1.2;
  padding: 0em;
  margin-top: 0.2em;
  margin-bottom: 0em;
}
.chart{
    padding-top: 10px;
}
</style>
